import { useEffect } from 'react';
import { setMonarchMonitoring } from '~/cohesion/Monarch/setMonarchMonitoring';
import { getAnonymousID } from '~/helper/parseURLParams';
import {
  useMonarchRule,
  useMonarchSlot,
  JsonObject,
} from '@redventures/cohesion-utils-react';

type MonarchEvaluationsValue = { [key: string]: JsonObject };

export default function useBeacon() {
  const evaluation = useMonarchRule<MonarchEvaluationsValue>('trafficFlow');
  const { slot } = useMonarchSlot<MonarchEvaluationsValue>('hero') as {
    slot?: {
      componentName?: string;
      componentId?: string;
    };
  };
  useEffect(() => {
    if (typeof window === 'undefined') return;

    setMonarchMonitoring();
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const evaluationReturnType = evaluation?.rule?.returnType;
    // const hasAAHero = slot?.componentName.includes('AA');
    const hasAAHero = slot?.componentName?.includes('AA') ?? false;
    const heroComponentId = slot?.componentId ?? null;

    // Fire Beacon overlayView event for W+ tracking after Monarch evaluation
    if (
      typeof window._bcq !== 'undefined' &&
      typeof evaluationReturnType !== 'undefined'
    ) {
      const data = {
        nm: {
          nm: 'rvLandingPageExp',
        },
        ov: {
          nm: 'rvLandingPageExp',
        },
        co: {
          ty: 'RV MLP',
          mx: getAnonymousID(),
          nm: hasAAHero ? 'Control' : 'Exp',
          ms: heroComponentId
            ? `Hero header: ${heroComponentId}`
            : 'Hero header: 1',
        },
        pg: {
          nm: 'rvLandingPage',
        },
      };
      window._bcq.push([
        '_tagAction',
        'wplus',
        'overlayView',
        'rvLandingPageExp',
        data,
      ]);
    }
  }, [evaluation]);
}
